const BASE = 'mdc-top-app-bar';
const SECTION = `${BASE}__section`;
const cssClasses = {
  BASE,
  ROW: `${BASE}__row`,
  SECTION,
  SECTION_START: `${SECTION}--align-start`,
  SECTION_END: `${SECTION}--align-end`,
  FIXED: `${BASE}--fixed`,
  SHORT: `${BASE}--short`,
  SHORT_COLLAPSED: `${BASE}--short-collapsed`,
  PROMINENT: `${BASE}--prominent`,
  DENSE: `${BASE}--dense`,
  TITLE: `${BASE}__title`,
  ACTION_ITEM: `${BASE}__action-item`,
  NAV_ICON: `${BASE}__navigation-icon`,
};

export {cssClasses};
